import * as React from 'react';
import * as styles from './styles.css';
import { trackRealtorBannerClick, trackRealtorBannerShown } from './tracking';

export interface ILeadRealtorBannerProps {
  url: string;
  isShown?: boolean;
}

export const LeadRealtorBanner: React.FC<ILeadRealtorBannerProps> = ({ url, isShown }) => {
  const [hasShown, setHasShown] = React.useState(false);
  React.useLayoutEffect(() => {
    if (isShown && !hasShown) {
      trackRealtorBannerShown();
      setHasShown(true);
    }
  }, [isShown, hasShown]);

  return (
    <a href={url} className={styles['container']} onClick={trackRealtorBannerClick}>
      <span className={styles['header']}>Помощь риелтора</span>
      <span className={styles['text']}>
        Риелтор поможет
        <br />
        купить или продать
        <br />
        любую недвижимость
      </span>
    </a>
  );
};

LeadRealtorBanner.displayName = 'LeadRealtorBanner';
